/**
 * Storage utilities for authentication
 */
import { TTL_KEY } from '../constants/auth.constants';

/**
 * Get TTL (Time To Live) for the authentication cookie
 */
export const getTTL = (): number | null => {
  const ttl = localStorage.getItem(TTL_KEY);
  return ttl ? Number.parseInt(ttl, 10) : null;
};

/**
 * Set TTL in localStorage
 */
export const setTTL = (ttl: number): void => {
  localStorage.setItem(TTL_KEY, ttl.toString());
};

/**
 * Remove TTL from localStorage
 */
export const removeTTL = (): void => {
  localStorage.removeItem(TTL_KEY);
};

/**
 * Check if TTL has expired
 */
export const isTTLExpired = (): boolean => {
  const ttl = getTTL();
  if (!ttl) {
    return true;
  }

  const now = Date.now();
  return now >= ttl;
};

/**
 * Get remaining TTL time in milliseconds
 */
export const getRemainingTTL = (): number => {
  const ttl = getTTL();
  if (!ttl) {
    return 0;
  }

  const now = Date.now();
  const remaining = ttl - now;
  return remaining > 0 ? remaining : 0;
};
